import { Step } from 'react-joyride';

export function filterJoyrideSteps(steps: Step[]): Step[] {
    return steps.filter((step) => {
        if (!step.target || step.target === 'body') {
            return true;
        }
        if (typeof step.target === 'string') {
            return document.querySelector(step.target) !== null;
        }
        return true;
    });
}
